
    import './styles.scoped.css';
    export default {
  "root": "_root_wf4fx_3",
  "header": "_header_wf4fx_13",
  "content": "_content_wf4fx_17",
  "error": "_error_wf4fx_21",
  "actions": "_actions_wf4fx_25"
};
  